var map = {
	"./en/bizCharge.json": 18405,
	"./en/bizTransaction.json": 8835,
	"./en/chat.json": 24354,
	"./en/common.json": 88045,
	"./en/couponHistory.json": 87310,
	"./en/couponIssue.json": 60701,
	"./en/cs.json": 50050,
	"./en/dashboard.json": 53524,
	"./en/feedbackReview.json": 5103,
	"./en/menu.json": 71255,
	"./en/order.json": 94640,
	"./en/product.json": 44343,
	"./en/productCategory.json": 17155,
	"./en/productRecent.json": 82756,
	"./en/store.json": 12173,
	"./ko/bizCharge.json": 48128,
	"./ko/bizTransaction.json": 9652,
	"./ko/chat.json": 47105,
	"./ko/common.json": 74846,
	"./ko/couponHistory.json": 56811,
	"./ko/couponIssue.json": 15412,
	"./ko/cs.json": 92173,
	"./ko/dashboard.json": 44489,
	"./ko/feedbackReview.json": 56516,
	"./ko/menu.json": 56796,
	"./ko/order.json": 6577,
	"./ko/product.json": 86662,
	"./ko/productCategory.json": 9342,
	"./ko/productRecent.json": 17949,
	"./ko/store.json": 15972,
	"./vn/bizCharge.json": 57910,
	"./vn/bizTransaction.json": 15898,
	"./vn/chat.json": 1907,
	"./vn/common.json": 92196,
	"./vn/couponHistory.json": 6249,
	"./vn/couponIssue.json": 71998,
	"./vn/cs.json": 41603,
	"./vn/dashboard.json": 88091,
	"./vn/feedbackReview.json": 862,
	"./vn/menu.json": 94734,
	"./vn/order.json": 35935,
	"./vn/product.json": 27516,
	"./vn/productCategory.json": 48724,
	"./vn/productRecent.json": 6791,
	"./vn/store.json": 88938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17246;